export enum NotificationType {
  QUOTE_SUBMITTED_FOR_APPROVAL = 'QUOTE_SUBMITTED_FOR_APPROVAL',
  QUOTE_APPROVED = 'QUOTE_APPROVED',
  QUOTE_REJECTED = 'QUOTE_REJECTED',
  QUOTE_ADJUSTMENT_REQUESTED = 'QUOTE_ADJUSTMENT_REQUESTED',
  /** Plan 2 de la épica H: una estrategia llegó a su fecha de fin. */
  STRATEGY_EXPIRED = 'STRATEGY_EXPIRED',
  /** Una cotización aprobada del Pricer venció: hay que revisarla y enviarla a aprobar de nuevo. */
  QUOTE_EXPIRED = 'QUOTE_EXPIRED',
  /** Se canceló una cotización que esperaba tu firma (o que habías creado). */
  QUOTE_CANCELLED = 'QUOTE_CANCELLED',
  /** «Para tu conocimiento»: lo recibe quien observa una cotización (F6 T14). */
  QUOTE_FOR_INFORMATION = 'QUOTE_FOR_INFORMATION',
  /** Una cotización supera el presupuesto del cliente: lo recibe el observador de sus líneas (F6 T13). */
  QUOTE_BUDGET_EXCEEDED = 'QUOTE_BUDGET_EXCEEDED',
  /** Monitoreo (25-oct): una tienda de la competencia cambió más precios que su mínimo. */
  COMPETITOR_PRICE_CHANGE = 'COMPETITOR_PRICE_CHANGE',
  /** Monitoreo (26-oct): una estrategia propuso precios que esperan una decisión. */
  PRICES_TO_DECIDE = 'PRICES_TO_DECIDE',
  /** Monitoreo (26-oct): los precios aprobados ya están en la tienda conectada. */
  PRICES_PUBLISHED = 'PRICES_PUBLISHED',
  /** Demo que vence (2-nov), a la plataforma: la prueba de una demo vence en pocos días. */
  DEMO_POR_VENCER = 'DEMO_POR_VENCER',
  /** Demo que vence (2-nov), a la plataforma: la prueba de una demo venció y la empresa se desactivó. */
  DEMO_VENCIDA = 'DEMO_VENCIDA',
  /** Landing nueva (vault 346), a la plataforma: llegó una solicitud de Mini Prixia (o un mensaje de Contacto). */
  SOLICITUD_MINI_PRIXIA = 'SOLICITUD_MINI_PRIXIA',
}

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  isRead: boolean;
  readAt: string | null;
  tenantId: string;
  userId: string;
  quoteId: string | null;
  /** La ficha del Pricer, si el aviso es de una cotización del Pricer (el servidor lo resuelve). */
  pricerDatecQuoteId?: string | null;
  approvalId: string | null;
  strategyApplicationId: string | null;
  /** La revisión de la competencia de la que avisa (Monitoreo, 25-oct). */
  monitorRunId?: string | null;
  createdAt: string;
  quote?: {
    id: string;
    code: string;
    clientName: string;
  } | null;
  strategyApplication?: { id: string; name: string } | null;
}

export interface NotificationListResponse {
  success: boolean;
  data: Notification[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface UnreadCountResponse {
  success: boolean;
  data: { count: number };
}
